module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/act/sections/apps/assets/flashcard_app-e8e957b48ad798da16744e5625948726.png";